import { useLocalStorageState, useRequest } from 'ahooks'
import { shopStore } from '@/store/shop'
import { useMemo } from 'react'
import { $post } from '@/api'
import { errorCallBack } from '..'
import dayjs from 'dayjs'
import $msg from '../message'

export const useDataRefresh = (options: { url: string; storageKey: string; onSuccess?: () => void }) => {
    const [refreshInfo, setRefreshInfo] = useLocalStorageState<Record<string, string>>(options.storageKey, {})

    const lastRefreshTime = useMemo(() => {
        if (!refreshInfo) {
            return ''
        } else {
            return refreshInfo[shopStore.shopInfo?.id || 0]
        }
    }, [refreshInfo])

    const refershReq = useRequest(
        () =>
            $post({
                url: options.url,
            }),
        {
            manual: true,
            onSuccess: () => {
                options.onSuccess && options.onSuccess()
                setRefreshInfo(
                    Object.assign({}, refreshInfo || {}, {
                        [shopStore.shopInfo?.id || 0]: dayjs().format('YYYY-MM-DD HH:mm:ss'),
                    }),
                )
                $msg('success', '刷新成功')
            },
            onError: errorCallBack,
        },
    )

    return {
        refresh: () => {
            if (lastRefreshTime) {
                const diff = dayjs(lastRefreshTime).add(1, 'minute').diff(dayjs(), 'second')
                if (diff > 0) {
                    return $msg('info', `刷新太频繁了，请${diff}秒后再试`)
                }
            }
            refershReq.run()
        },
        lastRefreshTime,
        loading: refershReq.loading,
    }
}
